import { translate } from '@washed/i18n';
import { Reveal } from '../motion/Reveal.js';
import { MaskedReveal } from '../motion/MaskedReveal.js';
import styles from './Technology.module.css';

export interface TechnologyProps {
  locale: 'fr' | 'en';
}

const FEATURES = ['continuity', 'schedule', 'payment', 'proof'] as const;

export function Technology({ locale }: TechnologyProps) {
  const t = (key: Parameters<typeof translate>[0]) => translate(key, locale);

  const features = FEATURES.map(
    (feature) =>
      [
        t(`marketing.technology.feature.${feature}.title`),
        t(`marketing.technology.feature.${feature}.body`),
      ] as const,
  );

  return (
    <section className={styles.section} id="technologie">
      <div className={styles.grid}>
        <div className={styles.copy}>
          <Reveal className={styles.eyebrow}>{t('marketing.technology.eyebrow')}</Reveal>
          <Reveal as="h2" variant="mask" className={styles.h2}>
            <MaskedReveal>{t('marketing.technology.head')}</MaskedReveal>
          </Reveal>
          <Reveal as="p" className={styles.lede} i={1}>
            {t('marketing.technology.body')}
          </Reveal>

          <dl className={styles.featureList}>
            {features.map(([title, body], index) => (
              <Reveal className={styles.feature} i={index + 2} key={title}>
                <dt>{title}</dt>
                <dd>{body}</dd>
              </Reveal>
            ))}
          </dl>
        </div>

        {/* A faithful sketch of the customer app's visit screen (Carnet): white
            page, grey group for the washer, the status track. Decorative. */}
        <Reveal className={styles.visual} i={2}>
          <div className={styles.phone} aria-hidden="true">
            <div className={styles.phoneTop}>
              <span className={styles.brand}>
                washed<span>.</span>
              </span>
              <span className={styles.status}>{t('marketing.technology.sample.status')}</span>
            </div>

            <p className={styles.visitLabel}>{t('marketing.technology.sample.nextVisit')}</p>
            <p className={styles.visitDay}>{t('marketing.technology.sample.day')}</p>
            <p className={styles.visitTime}>08:00 – 12:00</p>

            <div className={styles.workerGroup}>
              <div className={styles.avatar}>AK</div>
              <div>
                <strong>Akouvi K.</strong>
                <span>{t('marketing.technology.sample.washerRole')}</span>
              </div>
            </div>

            <ol className={styles.track}>
              <li data-done="">
                <strong>{t('marketing.technology.sample.confirmed')}</strong>
                <span>{t('marketing.technology.sample.confirmedDetail')}</span>
              </li>
              <li data-done="">
                <strong>{t('marketing.technology.sample.paid')}</strong>
                <span>Mixx by Yas · Flooz</span>
              </li>
              <li>
                <strong>{t('marketing.technology.sample.arrival')}</strong>
                <span>{t('marketing.technology.sample.arrivalDetail')}</span>
              </li>
              <li>
                <strong>{t('marketing.technology.sample.photos')}</strong>
                <span>{t('marketing.technology.sample.photosDetail')}</span>
              </li>
            </ol>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
